module.exports = __webpack_public_path__ + "static/media/5.d4e76c4c.png";